/* unplugin-vue-components disabled */import { render } from "./AppUpload.vue?vue&type=template&id=5060360f&scoped=true"
import script from "./AppUpload.vue?vue&type=script&lang=js"
export * from "./AppUpload.vue?vue&type=script&lang=js"

import "./AppUpload.vue?vue&type=style&index=0&id=5060360f&lang=scss&scoped=true"

import exportComponent from "D:\\Project\\Juanfu\\hcontrol_download\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5060360f"]])

export default __exports__